import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Button, InputGroup, Input, InputGroupAddon, InputGroupText,
  FormText, FormGroup, ButtonToolbar,
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import renderCheckBoxField from './CheckBox';

const validate = values => {
    const errors = {};
    if (!values.username) {
        errors.username = "Please enter the username";
    }
    if (!values.password) {
        errors.password = "Please enter the Password";
    }
    return errors;
};

const renderField = ({
    input,
    label,
    type,
    icon,
    meta: { touched, error, warning }
}) => (
        <FormGroup className="mb-3">
            <InputGroup>
                <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                        <i className={icon}></i>
                    </InputGroupText>
                </InputGroupAddon>
                <Input {...input} type={type} placeholder={label} /><br />
            </InputGroup>
            {touched && ((error && <FormText color="danger">{error}</FormText>))}
        </FormGroup>
    );

class LoginForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };

    this.showPassword = this.showPassword.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  }

  render () {
    const { handleSubmit, submitting } = this.props;
    const { showPassword } = this.state;

    return (
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__form-group">
          <span className="form__form-group-label">Enterprise Domain</span>
          <div className="form__form-group-field">
            <Field component={renderField} icon="icon-folder" type="text" label="Subdomain" name="subdomain" />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">Username</span>
          <div className="form__form-group-field">
            <Field component={renderField} icon="icon-user" type="text" label="Username" name="username" />
          </div>
        </div>

        <div className="form__form-group password-container">
          <span className="form__form-group-label">Password</span>
          <div className="form__form-group-field password">
            <Field
              component={renderField} icon="icon-lock" label="Password" name="password"
              type={showPassword ? 'text' : 'password'}
            />
            <span
              className={`${showPassword ? 'input-group-text active' : 'input-group-text'}`}
              onClick={e => this.showPassword(e)}
            >
              <i className="icon-eye"></i>
            </span>

          </div>
          <div className="login__forgot-password">
            <a href="#">Forgot a password?</a>
          </div>
        </div>
        <div className="form__form-group">
          <div className="form__form-group-field">
            <Field
              name="remember_me"
              component={renderCheckBoxField}
              label="Remember me"
            />
          </div>
        </div>

        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" disabled={submitting} type="submit">Sign In</Button>
        </ButtonToolbar>
      </form>
    );
  }
}

export default reduxForm({
    form: 'login',
    validate
})(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/forms/LoginForm.js